<div class="overflow-auto">
  <mat-spinner diameter="50" color="accent"></mat-spinner>
</div>
